const { dataUrl } = require('./municipalLogo.json');
const MUNICIPALITY = 'Prefeitura Municipal da Estância Turística de Presidente Epitácio - SP';

/** Cabeçalho comum a todos os documentos e páginas, com a imagem original da prefeitura. */
function drawMunicipalPdfHeader(doc, secretary, margin = 18) {
    const pageWidth = doc.internal.pageSize.getWidth();
    const top = 12;
    const logoWidth = 25;
    const logoHeight = logoWidth * 310 / 334;
    doc.addImage(dataUrl, 'PNG', margin, top, logoWidth, logoHeight, 'municipal-logo', 'FAST');
    const textX = margin + logoWidth + 7;
    const availableWidth = pageWidth - margin - textX;
    doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor(27, 45, 66);
    const title = doc.splitTextToSize(MUNICIPALITY, availableWidth);
    doc.text(title, textX, top + 5);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(10);
    const subtitle = doc.splitTextToSize(secretary || 'Secretaria não informada', availableWidth);
    const subtitleY = top + 5 + title.length * 4.8 + 2;
    doc.text(subtitle, textX, subtitleY);
    const bottom = Math.max(top + logoHeight, subtitleY + subtitle.length * 4.5) + 4;
    doc.setDrawColor(195, 202, 210); doc.line(margin, bottom, pageWidth - margin, bottom);
    return bottom + 8;
}
module.exports = { drawMunicipalPdfHeader, MUNICIPALITY };
